import { FC } from 'react';

import { getAuctionEditUrl } from 'utils/auction';
import { isAccountStatusReadOnly } from 'utils/clickme';
import { CampaignArchiveReason, CampaignStatus } from 'utils/constants/dashboard';

import { Link } from '@hh.ru/redux-spa-middleware';

import Button, { ButtonAppearance, ButtonIconPosition } from 'bloko/blocks/button';
import Icon, { IconScale, IconView } from 'bloko/blocks/icon';
import VSpacing from 'bloko/blocks/vSpacing';

import useTrls from 'hooks/translation/useTrls';

import { FrontendStatusType } from 'store/models/dashboard';
import { VacancyId } from 'store/models/mainMenu';
import { useSelector } from 'store/utils';

const AuctionSettings: FC<{
    vacancyId: VacancyId;
    archiveReason: CampaignArchiveReason | null;
    frontendStatus: FrontendStatusType;
}> = ({ frontendStatus, vacancyId }) => {
    const currentAccountStatus = useSelector((state) => state.user.user?.currentAccount.status);

    const trl = useTrls();

    if (frontendStatus === CampaignStatus.Archived || isAccountStatusReadOnly(currentAccountStatus)) {
        return null;
    }

    return (
        <>
            <Button
                appearance={ButtonAppearance.Outlined}
                icon={<Icon view={IconView.Gear} scale={IconScale.Small} />}
                iconPosition={ButtonIconPosition.Left}
                Element={Link}
                target="_blank"
                to={getAuctionEditUrl(vacancyId)}
                data-qa="auction-edit-button"
            >
                {trl('campaign.settings.edit')}
            </Button>
            <VSpacing base={4} />
        </>
    );
};

export default AuctionSettings;
